import { SurveyAnswer, SurveyResultAnswer } from "../interface"
import { AnswerType } from "../constants"

export function collectSurveyAnswers(answers: Record<string, SurveyAnswer>): SurveyResultAnswer[] {
    const result: SurveyResultAnswer[] = []

    Object.entries(answers).forEach(([key, value]) => {
        if (value.value === undefined) {
            return
        }
        if (value.type === AnswerType.choices) {
            const newValue =
                value.value &&
                Object.entries(value.value)
                    .filter(([_, valueItem]) => valueItem)
                    .map(([keyItem]) => keyItem)
            result.push({ id: key, value: newValue })
        } else if (value.type === AnswerType.yes_no) {
            result.push({ id: key, value: String(value.value) })
        } else if (value.type === AnswerType.number) {
            result.push({ id: key, value: Number(value.value) })
        } else {
            result.push({ id: key, value: String(value.value) })
        }
    })

    return result
}
